var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.526 13.807C11.6981 13.886 11.892 13.9041 12.0758 13.8582C12.2595 13.8123 12.4221 13.7052 12.5368 13.5545L12.8327 13.167C12.9879 12.96 13.1892 12.792 13.4207 12.6763C13.6521 12.5606 13.9073 12.5003 14.166 12.5003H16.666C17.108 12.5003 17.532 12.6759 17.8445 12.9885C18.1571 13.301 18.3327 13.725 18.3327 14.167V16.667C18.3327 17.109 18.1571 17.5329 17.8445 17.8455C17.532 18.1581 17.108 18.3337 16.666 18.3337C12.6878 18.3337 8.87246 16.7533 6.05941 13.9403C3.24637 11.1272 1.66602 7.31191 1.66602 3.33366C1.66602 2.89163 1.84161 2.46771 2.15417 2.15515C2.46673 1.84259 2.89065 1.66699 3.33268 1.66699H5.83268C6.27471 1.66699 6.69863 1.84259 7.01119 2.15515C7.32375 2.46771 7.49935 2.89163 7.49935 3.33366V5.83366C7.49935 6.0924 7.43911 6.34759 7.32339 6.57901C7.20768 6.81044 7.03968 7.01175 6.83268 7.16699L6.44268 7.45949C6.2897 7.57631 6.18187 7.74248 6.13751 7.92978C6.09315 8.11709 6.115 8.31397 6.19935 8.48699C7.33825 10.8002 9.21137 12.671 11.526 13.807Z",
    stroke: "currentColor",
    strokeWidth: 2.03175,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4a7212ef896c1316dd38be5365ef1a90.svg";
export { ForwardRef as ReactComponent };